<template>
  <div class="safe-view">
    <div class="view-title">安全设置</div>
    <div class="safe-body">
      <p>
        <span>登录账号：</span>
        <span>{{record.account}}</span>
      </p>
      <p>
        <span>上次登录时间：</span>
        <span>{{record.lastLoginTime}}</span>
      </p>
      <div class="safe-box">
        <div class="safe-item clear">
          <span class="item-header"><i class="iconfont iconmima"></i><span>登录密码</span></span>
          <span class="item-status"><i class="iconfont iconrenzhengchenggong"></i>已设置</span>
          <span class="item-text">信息加密保护中</span>
          <span class="item-tip">温馨提示：为保证您的帐号安全，建议您定期更换密码。</span>
          <a class="link"
             @click="$router.push({name: 'accountUpdatePassword'})">修改</a>
        </div>
        <div class="safe-item clear">
          <span class="item-header"><i class="iconfont iconfankui"></i><span>邮箱设置</span></span>
          <span class="item-status"><i class="iconfont iconrenzhengchenggong"></i>已绑定</span>
          <span class="item-text">您已设置了邮箱{{record.account}}</span>
          <a class="link"
             @click="$router.push({name: 'accountUpdateEmail'})">修改</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryApplicationList } from '@/api/personal/index'
export default {
  name: 'assessment',
  components: {

  },
  data () {
    return {
      apps: [{
        iconPath: null,
        appName: '',
        pkg: '',
        unfilled: 0,
        unsubmit: 0,
        audit: 0,
        failure: 0,
        success: 0
      }],
      statusMap: {
        unfilled: '未填写',
        unsubmit: '待提交',
        audit: '审核中',
        failure: '审核不通过',
        success: '评估完成'
      },
      size: 4,
      page: 1,
      total: 0
    }
  },
  computed: {
    record: function () {
      return this.$store.getters.getAccount
    }
  },
  methods: {
    imgPath (field) {
      return require(`@/assets/images/status/${field}.png`)
    },
    handlePageChange (page) {
      this.getData(page)
    },
    async getData (page) {
      if (page) this.page = page
      const params = {
        pageSize: this.size,
        currentPage: this.page
      }
      if (this.$route.query.status !== undefined) params.status = Number(this.$route.query.status)
      const data = await queryApplicationList(params)
      this.apps = data.data.data.list
      this.total = data.data.data.total
      this.apps.forEach(item => {
        let num = Object.keys(this.statusMap).reduce((total, cur) => {
          return total + item[cur]
        }, 0)
        this.$set(item, 'num', num)
      })
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang='less' scoped>
.safe-view {
  font-size: 14px;
  color: #666;
  .view-title {
    padding-bottom: 6px;
    margin-bottom: 30px;
    border-bottom: 2px solid #1f9b42;
    margin: 30px 0 12px;
  }
  .safe-body {
    > p {
      line-height: 25px;
    }
    .safe-box {
      border: 1px solid #ddd;
      margin-top: 12px;
      .safe-item {
        height: 64.5px;
        padding: 20px 30px 0;
        .item-header {
          display: inline-block;
          width: 200px;
          i {
            font-size: 20px;
            margin-right: 12px;
            vertical-align: middle;
          }
          > span {
            vertical-align: middle;
          }
        }
        .item-status {
          display: inline-block;
          width: 80px;
          i {
            font-size: 14px;
            margin-right: 10px;
          }
          color: #1f9b42;
        }
        .item-tip {
          margin-left: 20px;
          font-size: 12px;
          color: #999999;
        }
        a.link {
          color: #337ab7;
          cursor: pointer;
          float: right;
        }
      }
      .safe-item + .safe-item {
        border-top: 1px solid #ddd;
      }
    }
  }
}
</style>
